import React from "react";
import "./Footer.styles.scss";
import Image from "next/image";
import Link from "next/link";
const Footer = ({ containerProps, containerMethods }) => {
  const {
    socialMediaData,
    companySiteData,
    companyVehicleSiteData,
    locationInfo,
    phoneNumber,
    errors,
    isLoading,
  } = containerProps;
  const { handleSendButtonClick, handlePhoneNumberChange } = containerMethods;
  return (
    <div className="footerMainContainer">
      <div className="contactFormContainer">
        <p className="contactFormHeader">
          Have a question / concern? Contact us
        </p>
        <div className="contactFormInputContainer">
          <div className="contactForm">
            <input
              type="number"
              className="phoneNumberInput"
              placeholder="Enter your phone number"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              name="phoneNumber"
              id="phoneNumber"
            />
            <button
              className="sendButton"
              onClick={handleSendButtonClick}
              disabled={isLoading}
              style={{
                opacity: isLoading ? 0.5 : 1,
              }}
            >
              Send
            </button>
          </div>
          {errors.phoneNumber && (
            <div className="phoneNumberErrorText">{errors.phoneNumber}</div>
          )}
        </div>
      </div>
      <div className="socialMediaContainer">
        {socialMediaData?.map((item, index) => (
          <div
            key={`socialMediaInfoContainer-${index}`}
            className="socialMediaInfoContainer"
          >
            <div className="iconContainer">
              <Image src={item.icon} alt={item.label} width={30} height={30} />
            </div>
            <div className="socialMediaInfo">
              <div className="label">{item.label}</div>
              <div className="content">
                <Link className="content" href={item.link} target="_blank">
                  {item.content}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="companyFeaturesContainer">
        <div className="companyDetailsContainer">
          <div className="companyDetailsHeader">{companySiteData?.header}</div>
          {companySiteData?.company_sites?.map((item, index) => (
            <Link
              key={`company-details-${index}-${item?.label}`}
              className="companyDetailsLink"
              href={item.link}
              target={item?.newTab ? "_blank" : "_self"}
            >
              {item.label}
            </Link>
          ))}
        </div>
        <div className="companyVehiclePageDetailsContainer">
          <div className="companyVehiclePageHeader">
            {companyVehicleSiteData?.header}
          </div>
          {companyVehicleSiteData?.vehicle_sites?.map((item, index) => (
            <Link
              key={`company-vehicle-page-${index}-${item?.label}`}
              className="companyVehiclePageLink"
              href={item.link}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
      <div className="locationContainer">
        <h3 className="locationHeader">BUY USED ELECTRIC 3 WHEELERS IN</h3>
        <div className="locationInfo">
          {locationInfo?.map((item, index) => (
            <div
              key={`location-${index}-${item}`}
              className="locationLink"
              style={{ margin: index !== 0 ? "0px 4px 0px 0px" : "0px 4px 0px 0px" }}
            >
              {`${item}`}{" "}
              {index !== locationInfo.length - 1 && (
                <span className="divider">
                  <Image
                    src="https://assets.turnoclub.com/developer/innovolt/icons/vertical-line-icon.svg"
                    alt="verticla-line"
                    width={1}
                    height={4}
                  />
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="divider"></div>
      <div className="copyrightContainer">
        © Blubble Pvt Ltd | All rights reserved | The Turno brand is owned by
        Blubble Private Limited
      </div>
    </div>
  );
};

export default Footer;
